<script>
import api from "@/axios";
import Loader from "../components/loader.vue";
import Layout from '../../layouts/main.vue'
import PageHeader from '@/components/page-header.vue'
import ComprasTable from './compras-table.vue'
import appConfig from "@/app.config.json";
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import animationJson from '@/assets/animations/compras_anim.json'
import { pedidosChart1, pedidosChart2 } from "../components/data-simulados"
import exportFromJSON from "export-from-json"
import moment from "moment";
import Swal from "sweetalert2";
import {ref} from "vue";
import useVuelidate from "@vuelidate/core";
import DropZone from "@/components/widgets/dropZone.vue";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Compras",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {DropZone, Layout, PageHeader, ComprasTable, Loader, Vue3Lottie },
  mounted() {
    console.log('mounted compras-list_0')
    this.atualizaDataList()
  },
  data() {
    return {
      currentPage: 1,
      totalPages: 0,
      submittedPeriodo: false,
      dtIniFiltro: null,
      dtFimFiltro: null,
      showModalPeriodo: false,
      animationJson,
      title: 'Compras',
      valorTotal: 0,
      items: [
        {
          text: 'Estoque',
          href: '/',
        },
        {
          text: 'Compras',
          active: true,
        },
      ],
      loadingList: true,
      loadingGraph: true,
      pedidoList: null,
      pesqTextFilter: '',
      statusFilter: 'T',

      pedChart1: pedidosChart1,
      pedChart2: pedidosChart2,
      showModalImport: false,
      submittedAnexo: false,
      descranexo: '',
    }
  },

  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };

    // return { dropzoneFile, drop};
    return { v$: useVuelidate(), dropzoneFile, drop };
  },

  methods: {
    selectedFile(){
      console.log('selectedFile')
      this.dropzoneFile = document.querySelector(".dropzoneFile").files[0]
      console.log('selectedFile')
    },

    confirmarPeriodo(){
      console.log('confirmarPeriodo')
      this.showModalPeriodo = false
      this.atualizaDataList()

    },

    relatorio(){
      console.log('relatorio')
      this.loadingList = true

      api.get(`${getBaseUrl()}api/relcompra01`, {
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_compras_001.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loadingList = false
      })

    },


    getNotas(){
      console.log('getNotas')
      api.get(`${getBaseUrl()}api/getnotas`).then((res) => {
        console.log('then axios')
        console.log(res.data)
      });
    },

    atualizaPagina() {
      window.location.reload();
    },

    confImportar() {
      console.log('confImportar excel')

      let arquivo = document.querySelector(".dropzoneFile").files[0]
      let formData = new FormData()
      formData.append("file", arquivo)
      this.showModalImport = false
      this.loadingList = true

      api.post(`${getBaseUrl()}api/movcompraimpfile`,formData, { // movfileanexo
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((res) => {
        console.log('then axios confImportar excel')
        console.log(res)
        this.loadingList = false

        if (!res.data.success) {
          console.log('erro importação do excel...')

          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: res.data.message,
            showConfirmButton: false,
            timer: 2500
          }).then(() => {
            this.descranexo = ''
            this.dropzoneFile = ''
          })
        } else {
          console.log('redirecionando usuário para movcompra...')

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações importadas com sucesso!",
            showConfirmButton: false,
            timer: 2000
          }).then(() => {
            this.descranexo = ''
            this.dropzoneFile = ''

            this.$router.push(`/movcompra/editar/${res.data.id}`)
          })
        }
      }).catch((err) => {
        console.log('erro axios')
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof  erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros
        this.loadingFiles = false
        }).then(() => {
          this.descranexo = ''
          this.dropzoneFile = ''
        })
    },

    exportExcel(){
      console.log('exportExcel')
      const data = this.pedidoList
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },

    atualizaDataList(){

      if (!this.dtIniFiltro && !this.dtFimFiltro) {
        console.log('sem filtro')
        let perIniPadrao = moment().add(-30, 'days').startOf('month')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      this.loadingList = true
      api.get(`${getBaseUrl()}api/movcompras?page=${this.currentPage}`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter,
          'di': this.dtIniFiltro,
          'df': this.dtFimFiltro
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.pedidoList = res.data.data
        this.totalPages = (res.data.total + 2) * 10

        this.pedidoList.forEach((orccompra) => {
          this.valorTotal += orccompra.valorliq
        })

        const dtIniFormated = moment(this.dtIniFiltro)
            .format('DD/MM/YYYY')
        const dtFimFormated = moment(this.dtFimFiltro)
            .format('DD/MM/YYYY')

        this.title = `(${this.pedidoList.length}) Compras: ${dtIniFormated} - ${dtFimFormated}`
        this.loadingList = false
        this.loadingGraph = false
      });
    },

    criarNovo() {
      console.log('criarNovo')
      // this.updating = !this.updating
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    }

  },

}
</script>

<template>
  <Layout>

    <span class="float-end" style="z-index: 1000; position: absolute; top: 50px; right: 210px;">
      <Vue3Lottie :animationData="animationJson" :height="200" :width="200"/>
    </span>

    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">


              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        id="inputPesquisa"
                        type="text"
                        v-model="pesqTextFilter"
                        class="form-control"
                        placeholder="Enter para pesquisar..."
                        @change="atualizaDataList"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>


              <div class="col-sm-1">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <select
                        id="selectStatus"
                        v-model="statusFilter"
                        @change="atualizaDataList"
                        class="form-control select2-search-disable">
                      <option value="T" selected>Todos</option>
                      <option value="FA">Faturados</option>
                      <option value="EL">Elaboração</option>
                      <option value="CO">Confirmados</option>
                      <option value="CA">Cancelados</option>
                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>


              <div class="col-sm-2">

                <b-dropdown
                    ngbDropdown
                    menu-class="dropdown-menu-md dropdown-menu-end"
                    right
                    variant="light">
                  <template v-slot:button-content>
                    <i class="mdi mdi-help me-1"></i>
                    <span class="d-none d-sm-inline-block" ngbDropdownToggle>
                      Auxiliar
                      <i class="mdi mdi-chevron-down"></i>
                    </span>
                  </template>


                  <div v-if="!loadingList">
                    <div class="dropdown-item-text">
                      <div>
                        <p class="text-muted mb-2">Total</p>
                        <h5 class="mb-0">{{ formatDecimal(valorTotal) }} (líquido) </h5>
                      </div>
                    </div>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item>
                      Faturados:
                      <span class="float-end"> 0 (0%)</span>
                    </b-dropdown-item>
                    <b-dropdown-item>
                      Elaboração:
                      <span class="float-end"> 0 (0%)</span>
                    </b-dropdown-item>
                    <b-dropdown-item>
                      Confirmados:
                      <span class="float-end"> 0 (0%)</span>
                    </b-dropdown-item>
                    <b-dropdown-item>
                      Cancelados:
                      <span class="float-end"> 0 (0%)</span>
                    </b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <a class="dropdown-item text-primary text-center"
                       @click="showModalImport = true"
                       href="javascript: void(0);">
                      Importar Excel
                    </a>
                    s
                    <a class="dropdown-item text-primary text-center"
                       @click="exportExcel"
                       href="javascript: void(0);">
                      Exportar Excel
                    </a>

                    <b-dropdown-divider></b-dropdown-divider>
                    <a class="dropdown-item text-primary text-center"
                       @click="relatorio"
                       href="javascript: void(0);">
                      Relatório Compras no Período
                    </a>

                  </div>

                </b-dropdown>
              </div>


              <div class="col-sm-7">
                <div class="text-sm-end">
                  <router-link :to="`/movcompra/editar/0`">
                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2">
                      <i class="mdi mdi-plus me-1"></i> Nova Compra
                    </button>
                  </router-link>
                </div>

              </div>
            </div>


            <Loader v-if="loadingList" style="min-height: 400px;">
            </Loader>

            <ComprasTable v-if="!loadingList" :pedidoList="pedidoList"/>


            <!--            <ul class="pagination pagination-rounded justify-content-end mb-2">-->
            <!--              <li class="page-item disabled">-->
            <!--                <a class="page-link" href="javascript: void(0);" aria-label="Previous">-->
            <!--                  <i class="mdi mdi-chevron-left"></i>-->
            <!--                </a>-->
            <!--              </li>-->
            <!--              <li class="page-item active">-->
            <!--                <a class="page-link" href="javascript: void(0);">1</a>-->
            <!--              </li>-->
            <!--              <li class="page-item">-->
            <!--                <a class="page-link" href="javascript: void(0);">2</a>-->
            <!--              </li>-->
            <!--              <li class="page-item">-->
            <!--                <a class="page-link" href="javascript: void(0);">3</a>-->
            <!--              </li>-->
            <!--              <li class="page-item">-->
            <!--                <a class="page-link" href="javascript: void(0);">4</a>-->
            <!--              </li>-->
            <!--              <li class="page-item">-->
            <!--                <a class="page-link" href="javascript: void(0);">5</a>-->
            <!--              </li>-->
            <!--              <li class="page-item">-->
            <!--                <a class="page-link" href="javascript: void(0);" aria-label="Next">-->
            <!--                  <i class="mdi mdi-chevron-right"></i>-->
            <!--                </a>-->
            <!--              </li>-->
            <!--            </ul>-->
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">

                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalPages"
                        @update:modelValue="atualizaDataList">
                    </b-pagination>

                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>

    <div class="row" v-if="!loadingGraph">

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Evolução Anual</h4>

            <apexchart
                class="apex-charts"
                height="350"
                type="line"
                dir="ltr"
                :series="pedChart1.series"
                :options="pedChart1.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Fornecedores</h4>

            <apexchart
                class="apex-charts"
                height="320"
                type="pie"
                dir="ltr"
                :series="pedChart2.series"
                :options="pedChart2.chartOptions"
            ></apexchart>

          </div>
        </div>
      </div>


    </div>

    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span>Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span>Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <b-modal 
    title="Criar Novo Anexo" 
    v-model="showModalImport" 
    centered 
    hide-footer
    @hide="dropzoneFile = ''">
      <div>
        <div class="card-body">
          <h4 class="card-title">Selecionar novo arquivo</h4>
          <DropZone @change="selectedFile" />
          <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
          <div v-if="submittedAnexo && !dropzoneFile.name" >
            <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <label for="descranexo">Descrição</label>
              <div class="position-relative">
                <input
                    id="descranexo"
                    type="text"
                    v-model="descranexo"
                    class="form-control"
                    placeholder="Descrição do anexo"
                    :class="{'is-invalid': submittedAnexo && !descranexo}"/>
                <div v-if="submittedAnexo && !descranexo" class="invalid-feedback">
                  <span>Campo descrição obrigatório, favor preencher.</span>
                </div>

              </div>
            </div>
          </div>
        </div>


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalImport = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confImportar">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


  </Layout>
</template>